module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"instruction":"Drag n drop to create the Memo story"},"en":{"instruction":"Drag n drop to create the Memo story"}}')
  delete Component.options._Ctor
}
